export default __webpack_public_path__ + "static/media/accept-eula.ff213792.png";